import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Constant } from 'src/app/constants/constant';
import { CommonService } from 'src/app/services/common.service';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { RestaurantsService } from 'src/app/services/restaurants.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-restaurants',
  templateUrl: './restaurants.component.html',
  styleUrls: ['./restaurants.component.scss']
})
export class RestaurantsComponent implements OnInit {
  page: number;
  size: number;
  sortParam: string;
  partnerList: any;
  secondaryTenantId: any;

  @Input() showCartIcon: any;
  @Input() data: any;
  @Input() showCartIncremented:any;

  dumdata: any;
  item_visible:boolean = false;
  public bigImage = environment.ImageAPI1;
  public serverPath7 = environment.commonImageApi+"catalog/product";
  enableEnquire: any;
  b2bPricingEnabled: any;
  decimalDigit: any;
  deliveryDoorStepIcon: boolean;
  deliveryTime: any;
  showTimeIcon: boolean;
  showGenuineProductIcon: boolean;
  genuineProductText: any;
  deliveryDoorStepText: any;
  showConfigurableDropdown: any;
  productDetailPage: any;
  crossSellProductsText: any;
  relatedProductsText: any;
  recentlyViewedProductsText: any;
  upSellProductsText: any;
  productImageHeight: any;
  productImageWidth: any;
  productImageType: any;
  productDetailImageWidth: any;
  productzoom: any;
  productImageWidthMob: any;
  productImageHeightMob: any;
  productDetailHeight: any;
  productDetailWidth: any;
  productDetailHeightMobile: any;
  productDetailWidthMobile: any;
  showExclusivePrice: any;
  productDetailPageSubimageHeight: any;
  distance: any;

  constructor(
    private restaurantsService: RestaurantsService,
    private configService: ConfigServiceService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,) { }

  
  ngOnInit() {
    
    this.secondaryTenantId = this.route.snapshot.params['id'];
    this.getAllPartner();

    this.getConfigData()

  }


  getAllPartner() {
    this.page = 0;
    this.size = 10;
    this.sortParam = "entityId,DESC";
    this.restaurantsService.getAllRestaurants(this.page, this.size, this.sortParam , this.secondaryTenantId).subscribe(
      res => {
        this.partnerList = res['content'];
      },
      error => {
      }
    )
  }

  toggleSection(){
    this.item_visible = !this.item_visible;
  }
  
  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        data => {
          localStorage.setItem(Constant['GUEST_LOGIN'], data['guestLogin'])

          let url = data['baseUrl'] + this.router.url;


          this.commonService.setCurrencyValue(data['currencyBase'])

          this.showCartIcon = data['showCartProductPage'];

          this.enableEnquire = data['enableEnquire'];

          this.b2bPricingEnabled = data['b2bPricingEnabled'];

          this.decimalDigit=data['decimalDigit'];
          
          this.showCartIncremented = data['showCartIncremented']

          this.deliveryDoorStepIcon = data['deliveryDoorStepIcon'] == 1 ? true : false

          this.deliveryTime = data['deliveryTime']

          this.showTimeIcon = data['showTimeIcon'] == 1 ? true : false

          this.showGenuineProductIcon = data['showGenuineProductIcon'] == 1 ? true : false;

          this.genuineProductText = data['genuineProductText']

          this.deliveryDoorStepText = data['deliveryDoorStepText'];

          this.showConfigurableDropdown = data['showConfigurableDropdownProductPage'];

          this.productDetailPage = data['productDetailPage'];

          this.crossSellProductsText = data['crossSellProductsText']

          this.relatedProductsText = data['relatedProductsText'];

          this.recentlyViewedProductsText = data['recentlyViewedProductsText']

          this.upSellProductsText = data['upSellProductsText']

          this.productImageHeight = data['productsImageHeight']

          this.productImageWidth = data['productsImageWidth']

          this.productImageType = data['productsImageType']

          this.productDetailImageWidth = data['productImageWidth']

          this.productzoom = data['productzoom']

          this.data = data;

          this.productImageWidthMob = data['productsImageWidthMob']

          this.productImageHeightMob = data['productsImageHeightMob'];


          this.productDetailHeight = data['productImageHeight'];
          this.productDetailWidth = data['producImageWidth'];

          this.productDetailHeightMobile = data['productMImageHeight'];
          this.productDetailWidthMobile = data['productMImageWidth'];

          this.showExclusivePrice = data['showExclusivePrice']

          this.productDetailPageSubimageHeight = data['productDetailPageSubimageHeight'];

          this.distance=data['deliveryRange'];


        }, error => {

        }
      );
  }


}
